import { Map } from 'immutable'

export const customImageStyles = [
  // ----- Fixed height
  '420x236', // LINKGRID
  '420x236_webp', // LINKGRID
  '840x472_webp', // LINKGRID
  '170x170', // QUOTE (mobile)
  '170x170_webp', // QUOTE (mobile)
  '340x340_webp', // QUOTE (mobile)
  '475x356', // QUOTE (desktop)
  '475x356_webp', // QUOTE (desk)
  '950x712_webp', // QUOTE (desk)
  '439x266_webp', // TEXT W. IMG
  '878x532', // TEXT W. IMG
  '878x532_webp', // TEXT W. IMG
  '1756x1064_webp', // TEXT W. IMG
  '644x483', // CTA W. IMG
  '644x483_webp', // CTA W. IMG
  '1288x966_webp', // CTA W. IMG
  '310x206', // RECENT NEWS
  '310x206_webp', // RECENT NEWS
  '620x412_webp', // RECENT NEWS
  '596x447', // FEATURED CONTENT
  '596x447_webp', // FEATURED CONTENT
  '1192x894_webp', //FEATURED CONTENT
  '185x124', // SEARCH
  '185x124_webp', // SEARCH
  '370x248_webp', // SEARCH
  // '542x241_webp', // PAGEHEADER W. IMG (small)
  // '1058x482', // PAGEHEADER W. IMG (small)
  // '1058x482_webp', // PAGEHEADER W. IMG (small)
  // '1626x723_webp', // PAGEHEADER W. IMG (small)
  '640x500', // PAGEHEADER W. IMG (large - mobile)
  '640x500_webp', // PAGEHEADER W. IMG (large - mobile)
  '1280x1000_webp', // PAGEHEADER W. IMG (large - mobile)
  '1280x500', // PAGEHEADER W. IMG (large - tablet)
  '1280x500_webp', // PAGEHEADER W. IMG (large - tablet)
  '1920wx750_webp', // PAGEHEADER W. IMG (large - tablet)
  '1920x500', // PAGEHEADER W. IMG (large - desktop)
  '1920x500_webp', // PAGEHEADER W. IMG (large - desktop)
  '2880x750_webp', // PAGEHEADER W. IMG (large - desktop)
  '441x373_webp', // HOMEHEADER
  '882x746', // HOMEHEADER
  '882x746_webp', // HOMEHEADER
  '1764x1492_webp', // HOMEHEADER
  '1280x640', // DONATION HEADER
  '640x320_webp', // DONATION HEADER
  '1280x640_webp', // DONATION HEADER
  '2560x1280_webp', // DONATION HEADER
  // ----- Fluid height
  '433w_webp', // MEDIA CONTENT
  '656w_webp', // MEDIA FULL
  '866w', // MEDIA CONTENT
  '866w_webp', // MEDIA CONTENT
  '1312w', // MEDIA FULL
  '1312w_webp', // MEDIA FULL
  '1732w_webp', // MEDIA CONTENT
  '2624w_webp', // MEDIA FULL
  '520w', // POPUP
  '520w_webp', // POPUP
  '1040w_webp', // POPUP
  'full', // MEDIA ORIGINAL
  'full_webp' // MEDIA ORIGINAL
] as const

const imageStyles = [...customImageStyles, 'large', 'crop_thumbnail', 'medium', 'thumbnail', 'wide'] as const
export type DPImageStyle = typeof imageStyles[number]

// Default

export const defaultSrcSet: Map<DPImageStyle, string> = Map([
  ['medium', '620w'],
  ['large', '1240w']
])

// Link grid block

export const linkGridSrc: DPImageStyle = '420x236'
export const linkGridSrcSet: Map<DPImageStyle, string> = Map([
  ['420x236_webp', '420w'],
  ['840x472_webp', '840w']
])

// Link grid block (mobile - 4:3 crop)
export const linkGridSrcMobile: DPImageStyle = '596x447'
export const linkGridSrcSetMobile: Map<DPImageStyle, string> = Map([
  ['596x447_webp', '596w'],
  ['1192x894_webp', '1192w']
])

// Media

export const mediaContentSrc: DPImageStyle = '866w'
export const mediaContentSrcSet: Map<DPImageStyle, string> = Map([
  ['433w_webp', '433w'],
  ['866w_webp', '866w'],
  ['1732w_webp', '1732w']
])

export const mediaFullSrc: DPImageStyle = '1312w'
export const mediaFullSrcSet: Map<DPImageStyle, string> = Map([
  ['656w_webp', '656w'],
  ['1312w_webp', '1312w'],
  ['2624w_webp', '2624w']
])

export const mediaOrginalSrc: DPImageStyle = 'full'
export const mediaOrginalSrcSet: Map<DPImageStyle, string> = Map([
  ['full_webp', '1x']
])

export const mediaNestedSrc: DPImageStyle = mediaContentSrc
export const mediaNestedSrcSet: Map<DPImageStyle, string> = mediaContentSrcSet


// Quote

export const quoteSrc: DPImageStyle = '170x170'
export const quoteSrcSet: Map<DPImageStyle, string> = Map([
  ['170x170_webp', '170w'],
  ['340x340_webp', '340w']
])
export const quoteSrcDesktop: DPImageStyle = '475x356'
export const quoteSrcSetDesktop: Map<DPImageStyle, string> = Map([
  ['475x356_webp', '475w'],
  ['950x712_webp', '950w']
])

// Text w. Image

export const textImageSrc: DPImageStyle = '878x532'
export const textImageSrcSet: Map<DPImageStyle, string> = Map([
  ['439x255_webp', '439w'],
  ['878x532_webp', '878w'],
  ['1756x1064_webp', '1756w']
])

export const textImageCompactSrc: DPImageStyle = '866w'
export const textImageCompactSrcSet: Map<DPImageStyle, string> = Map([
  ['433w_webp', '433w'],
  ['866w_webp', '866w'],
  ['1732w_webp', '1732w']
])

// CTA w. Image

export const ctaSrc: DPImageStyle = '644x483'
export const ctaSrcSet: Map<DPImageStyle, string> = Map([
  ['644x483_webp', '644w'],
  ['1288x966_webp', '1288w']
])

// Recent News

export const recentNewsSrc: DPImageStyle = '310x206'
export const recentNewsSrcSet: Map<DPImageStyle, string> = Map([
  ['310x206_webp', '310w'],
  ['620x412_webp', '620w']
])

// Search

export const searchSrc: DPImageStyle = '185x124'
export const searchSrcSet: Map<DPImageStyle, string> = Map([
  ['185x124_webp', '185w'],
  ['370x248_webp', '370w']
])

// Pageheader & Homeheader

export const homeHeaderSrc: DPImageStyle = '882x746'
export const homeHeaderSrcSet: Map<DPImageStyle, string> = Map([
  ['441x373_webp', '441'],
  ['882x746_webp', '881w'],
  ['1764x1492_webp', '1762w']
])

export const pageheaderSmallSrc: DPImageStyle = '882x746'
export const pageheaderSmallSrcSet: Map<DPImageStyle, string> = Map([
  ['441x373_webp', '441'],
  ['882x746_webp', '881w'],
  ['1764x1492_webp', '1762w']
])

// Donation-page header (2:1 crop)
export const donationHeaderSrc: DPImageStyle = '1280x640'
export const donationHeaderSrcSet: Map<DPImageStyle, string> = Map([
  ['640x320_webp', '640w'],
  ['1280x640_webp', '1280w'],
  ['2560x1280_webp', '2560w']
])

export const pageheaderLargeSrc: DPImageStyle = '640x500'
export const pageheaderLargeSrcSet: Map<DPImageStyle, string> = Map([
  ['640x500_webp', '640w'],
  ['1280x1000_webp', '1280w']
])
export const pageheaderLargeSrcTablet: DPImageStyle = '1280x500'
export const pageheaderLargeSrcSetTablet: Map<DPImageStyle, string> = Map([
  ['1280x500_webp', '1280w'],
  ['1920wx750_webp', '1920']
])
export const pageheaderLargeSrcDesktop: DPImageStyle = '1920x500'
export const pageheaderLargeSrcSetDesktop: Map<DPImageStyle, string> = Map([
  ['1920x500_webp', '1920w'],
  ['2880x750_webp', '2560w']
])

// Popup

export const popupSrc: DPImageStyle = '520w'
export const popupSrcSet: Map<DPImageStyle, string> = Map([
  ['520w_webp', '520w'],
  ['1040w_webp', '1040w']
])

// Popup

export const featuredContentSrc: DPImageStyle = '596x447'
export const featuredContentSrcSet: Map<DPImageStyle, string> = Map([
  ['596x447_webp', '596w'],
  ['1192x894_webp', '1192w']
])

// UNUSED

export const contactSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const imageGalleryTeasersSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const imageGalleryOverlaySrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const logoWallSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const overviewsMobileSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const overviewDesktopSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const overviewBlockDesktopSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const donationFormSrcSet: Map<DPImageStyle, string> = defaultSrcSet
export const highlightImageSrcSet: Map<DPImageStyle, string> = defaultSrcSet
